import React from 'react';
import './MarriottDigitalCards.css';
import OptimizedImage from './OptimizedImage';

import laptopCardImage from 'url:../../assets-optimized/redesign/solutions/marriott-digital/laptop_card.png';
import laptopCardImageavif from 'url:../../assets-optimized/redesign/solutions/marriott-digital/laptop_card.avif';
import laptopCardImagewebp from 'url:../../assets-optimized/redesign/solutions/marriott-digital/laptop_card.webp';

const MarriottDigitalCards = () => {
  return (
    <section className="md-cards-section">
      <div className="md-cards-container">
        <div className="md-card md-card--web">
          <div className="md-card__content">
            <h2 className="md-card__title">WEB</h2>
            <p className="md-card__text">
              Our web placements reach travelers while they're actively exploring stays, discovering offers, and managing their trips.
            </p>
          </div>
          <div className="md-card__image-container">
            <OptimizedImage avif={laptopCardImageavif} webp={laptopCardImagewebp} fallback={laptopCardImage} alt="Web Placement Laptop" className="md-card__image" />
          </div>
        </div>
        <div className="md-card md-card--app">
          <h2 className="md-card__title">APP</h2>
          <p className="md-card__text">
            Integrate the your brand message directly in the headline or subhead.
          </p>
        </div>
        <div className="md-card md-card--email">
          <h2 className="md-card__title">EMAIL</h2>
          <p className="md-card__text">
            Join our guests as they receive Monthly Account Updates, and start to plan their Escapes.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MarriottDigitalCards;